module.exports = __webpack_public_path__ + "static/media/mbj_home.e505aa1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/MyBabyJo/mbj_home.jpg
// module id = 683
// module chunks = 0